import { render, staticRenderFns } from "./tabText.vue?vue&type=template&id=be9420c0&scoped=true&"
import script from "./tabText.vue?vue&type=script&lang=js&"
export * from "./tabText.vue?vue&type=script&lang=js&"
import style0 from "./tabText.vue?vue&type=style&index=0&id=be9420c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9420c0",
  null
  
)

export default component.exports